import React from 'react'
import styles from '../styles/FooterSection.module.css'
import footerLogo from '../../../assets/image/logo/thickWalletOnly.png'
import {useHistory} from "react-router-dom";
import Reveal from '../../../components/Animations/RevealEffect/Reveal';

const FooterSection = () => {
    const history = useHistory();
    return (
        <Reveal>
            <div id={"footerSection"}>
                <section className={styles.footer_main_container}>
                    <div className="container-fluid">
                        <Reveal>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <div className={styles.footer_desc_section}>
                                        <h1>Let's start your investment <span>now</span></h1>
                                        <button onClick={() => history.push('/signup')}>Join Us</button>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <div className={styles.footer_subscribe_section}>
                                        <p>Subscribe newsletter for latest stock activities.</p>
                                        <div className={styles.subscription_input_wrapper}>
                                            <input type="text" placeholder='Enter Email Address' />
                                            <button>subscribe</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-4">
                                    <div className={styles.footer_address_section}>
                                        <img src={footerLogo} alt="" width={200} height={50} />
                                        <p><span>Email</span> : info@thick-wallet.com</p>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </section>
                <div className={styles.footer_copyright_section}>
                    <div className='container-fluid'>
                        <Reveal>
                            <div className="row justify-content-center">
                                <div className="col-auto">
                                    <div className={styles.copyright_text}>
                                        <p>Copyright ©2025 Thick-Wallet. All rights reserved.</p>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </Reveal>
    )
}

export default FooterSection
